import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const actionType = {
	SetOrgano: '[ORGANO] SET_ORGANO',
};

export const initialSelectedCollegiate = {
	id: '',
	name: '',
};

const initialState = {
	organo: {},
};

export const reducer = persistReducer(
	{ storage, key: 'organos', whitelist: ['organo'] },
	(state = initialState, action) => {
		switch (action.type) {
			case actionType.SetOrgano:
				return { ...state, organo: action.payload };

			default:
				return state;
		}
	}
);

export const actions = {
	setOrgano: (data) => ({
		type: actionType.SetOrgano,
		payload: data,
	}),
};
